import { CompetitorDossierView, GrowthDashboardTopBarActions } from '@elva/ui';
import { useParams } from 'react-router-dom';
import { AsyncBoundary } from '@/components/feedback';
import { usePageTopBar } from '@/app/layouts/pageTopBar';
import { viewProps } from '@/data/viewProps';
import { useCompetitorDossier, useCompetitorMutations } from '../hooks/useCompetitors';

export function CompetitorDossierPage() {
  const { competitorId = '' } = useParams();

  usePageTopBar({
    actions: <GrowthDashboardTopBarActions />,
  });

  const { data, isPending, isError, error, refetch, isRefetching, isFetching } =
    useCompetitorDossier(competitorId);
  const { recrawl } = useCompetitorMutations();

  return (
    <AsyncBoundary
      loading={isPending}
      error={data === undefined && isError ? error : undefined}
      onRetry={refetch}
      retrying={isRefetching}
    >
      <CompetitorDossierView
        {...viewProps({
          header: data ?? undefined,
          loading: isFetching || recrawl.isPending,
          onRecrawl: () => recrawl.mutate(competitorId),
        })}
      />
    </AsyncBoundary>
  );
}
